import { Col, Container, Row } from 'reactstrap';

const FooterUser = () => {
    return (
        <div className="border-top-footer">
            <Container>
                <Row >
                    <Col className="text-center black-text font-small font-weight-light pb-3">
                        &copy;{new Date().getFullYear()} <a href="/" className="text-white">FaraBazaar.ir</a>. All Rights Reserved.
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default FooterUser;
